module.exports = __webpack_public_path__ + "img/7748bd3.png";